import React from 'react';
import { Grid, Typography, Link, Paper, Stack, Box } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { BOOK_URL } from '../config';
import pkg from '../../package.json';
import { useT } from '../i18n/LanguageContext';
import { openCookiePreferences } from './CookieBanner';

const APP_VERSION = pkg.version;

const Footer = () => {
  const theme = useTheme();
  const t = useT();
  return (
    <Paper sx={{ width: '100vw', maxWidth: '100%', bgcolor: theme.home.ink, color: theme.home.paper, borderRadius: 0 }} elevation={0}>
      <Grid container spacing={4} sx={{ p: { xs: theme.spacing(4), md: theme.spacing(6) } }}>
        <Grid item xs={12} sm={4}>
          <Typography component="h3" variant="subtitle1" gutterBottom sx={{ fontFamily: theme.home.display, fontWeight: 700 }}>
            Sinergie Generative
          </Typography>
          <Typography variant="body2" sx={{ color: 'rgba(251,248,244,0.7)', maxWidth: 280 }}>
            {t('footer.tagline')}
          </Typography>
          <Link href={BOOK_URL} target="_blank" rel="noopener noreferrer" color="inherit" variant="body2"
            sx={{ display: 'inline-block', mt: 1.5 }}>
            {t('footer.bookLink')}
          </Link>
        </Grid>

        <Grid item xs={12} sm={4}>
          <Typography component="h3" variant="subtitle1" gutterBottom>
            {t('footer.siteHeading')}
          </Typography>
          <Stack spacing={0.75}>
            <Link component={RouterLink} to="/#come-funziona" color="inherit" variant="body2">{t('footer.howItWorks')}</Link>
            <Link component={RouterLink} to="/metodo" color="inherit" variant="body2">{t('footer.method')}</Link>
            <Link component={RouterLink} to="/#pricing" color="inherit" variant="body2">{t('footer.pricing')}</Link>
            <Link component={RouterLink} to="/#faq" color="inherit" variant="body2">{t('footer.faq')}</Link>
          </Stack>
        </Grid>

        <Grid item xs={12} sm={4}>
          <Typography component="h3" variant="subtitle1" gutterBottom>
            {t('footer.contactHeading')}
          </Typography>
          <Typography variant="body2">
            {t('footer.contactIntro')} <Link href="mailto:info@fluel.it" color="inherit">info@fluel.it</Link>
          </Typography>
          <Stack spacing={0.5} sx={{ mt: 1.5 }}>
            <Link href="/privacy" color="inherit" variant="caption">{t('footer.privacyPolicy')}</Link>
            <Link component={RouterLink} to="/cookie-policy" color="inherit" variant="caption">{t('footer.cookiePolicy')}</Link>
            <Link component="button" type="button" onClick={openCookiePreferences} color="inherit" variant="caption"
              sx={{ textAlign: 'left' }}>
              {t('footer.cookiePreferences')}
            </Link>
          </Stack>
        </Grid>
      </Grid>
      <Box sx={{ textAlign: 'center', pb: 2 }}>
        <Typography variant="caption" sx={{ color: 'rgba(251,248,244,0.4)' }}>
          v{APP_VERSION} · {t('footer.beta')}
        </Typography>
      </Box>
    </Paper>
  );
};

export default Footer;
